module.exports = __webpack_public_path__ + "img/avatar4.07d907c1.png";